import HubspotMeetingEmbed from '@app/components/hubspot-meeting-embed';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@shared/components/ui/dialog';
import { useCallback, useState } from 'react';
import useUpsellDialog from './use-upsell-dialog';

export const useCCFUpsellDialog = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const showDialog = useCallback(() => {
    setIsDialogOpen(true);
  }, []);

  const UpsellDialogComponent = (
    <UpsellDialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} />
  );

  return {
    showDialog,
    UpsellDialogComponent,
  };
};

interface UpsellDialogProps {
  open?: boolean;
  onClose?: () => void;
}

function UpsellDialog({ open, onClose }: UpsellDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen && onClose) onClose();
      }}
    >
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle className="px-6 pt-6 text-3xl font-bold text-primary-800">
            Unlock your Scope 3 emissions
          </DialogTitle>
          <DialogDescription className="px-6 py-2 text-base font-normal text-gray-800">
            For food businesses like yours, Scope 3 emissions can be around 90%
            of your total carbon footprint, with emissions from purchased food
            and drink being the largest contributor. Our platform makes it easy
            to measure and report your Scope 3 emissions, as our AI-powered
            pipeline can automatically calculate your emissions from your
            purchase data!
            <br />
            <br />
            Book a call below to get started with your Scope 3 today.
            <div className="mt-2">
              <HubspotMeetingEmbed className=" mt-2 h-[664px] w-full" />
            </div>
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}

export default useUpsellDialog;
